import { createLogic } from 'redux-logic';

import {
  searchCustomersFulfilled,
  searchCustomersRejected,
} from 'store/searchCustomers/actions';
import {
  SEARCH_CUSTOMERS,
  SearchCustomersAction,
} from 'store/searchCustomers/types';
import { AppState } from 'store/store';
import { findMember } from 'lava/api';

export const searchCustomersLogic = createLogic({
  type: SEARCH_CUSTOMERS,
  latest: true,

  async process(
    {
      action,
      getState,
    }: { action: SearchCustomersAction; getState: () => object },
    dispatch,
    done
  ) {
    const searchValue = action.payload;

    const posContext = (getState() as AppState).context.posContext;

    try {
      const customers = await findMember(posContext, searchValue);

      dispatch(searchCustomersFulfilled(customers));
    } catch (error) {
      dispatch(searchCustomersRejected({ apiError: error as Error }));
    } finally {
      done();
    }
  },
});
